export const contactsKeys = {
	all: () => ['contacts'],
	load: () => ['contacts', 'load'],
};
